import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SetShowAuthorIdState {
  id: string
}

const initialState: SetShowAuthorIdState = {
  id: ''
}

export const setShowAuthorIdSlice = createSlice({
  name: 'setShowAuthorId',
  initialState,
  reducers: {
    setShowAuthorId: (state, action: PayloadAction<string>) => {
      state.id = action.payload
    }
  }
})
export const { setShowAuthorId } = setShowAuthorIdSlice.actions
export default setShowAuthorIdSlice.reducer
